import { DateRange } from "util/time";

export enum ContactReason {
  OccupyingSpace = "occupying_space",
  WebsiteHelp = "website_help",
  Site = "site",
  Other = "other",
}

export interface MessageRequest {
  name: string;
  email: string;
  phoneNumber: string | null;
  company?: string;
  reason: ContactReason;
  location?: string;
  message?: string;
}

export interface BookingEnquiryUser {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  companyName: string;
  space?: string;
}

export interface BookingEnquiryRequest {
  space: string;
  times?: DateRange[];
  user: BookingEnquiryUser | null;
}

export enum SupportRequestType {
  Booking,
  Designing,
  Other,
}

export interface SupportRequest {
  firstName: string;
  lastName: string | null;
  email: string;
  phoneNumber: string | null;
  type: SupportRequestType | null;
  summary: string;
  description: string;
  attachment: File | null;
}
